import { render, staticRenderFns } from "./LoginResellerLayout.vue?vue&type=template&id=ed4d321a&scoped=true"
import script from "./LoginResellerLayout.vue?vue&type=script&lang=js"
export * from "./LoginResellerLayout.vue?vue&type=script&lang=js"
import style0 from "./LoginResellerLayout.vue?vue&type=style&index=0&id=ed4d321a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4d321a",
  null
  
)

export default component.exports